module.exports = __webpack_public_path__ + "static/media/default.c81bf580.jpg";